import React from 'react';
import { observer } from 'mobx-react';
import DeviceDeleteComponent from './Device-delete.component';
import useDeviceDelete from './useDeviceDelete';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { devices, groups, app, lang, state, handlers } =
        useDeviceDelete(onClose);

    return (
        <>
            <DeviceDeleteComponent
                lang={lang.lang}
                loading={
                    devices.deleteDeviceLoading ||
                    groups.loading ||
                    devices.loading
                }
                deviceName={state.deviceName}
                serverError={devices.serverError}
                demoModeError={app.demoModeError}
                onConfirmClick={handlers.handleConfirmClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onCancelClick={onClose}
            />
        </>
    );
};

const DeviceDeleteContainer = observer(Container);

export default DeviceDeleteContainer;
